module.exports = __webpack_public_path__ + "img/full1-min.99b1cbf0.png";